import { gql } from "@apollo/client"

export const GET_SCHOOL_ADMIN = gql`
  query getSchoolAdmin($id: String!, $orgRefScope: OrgRefScope!) {
    schoolAdmin {
      get(id: $id, orgRefScope: $orgRefScope) {
        id
        firstName
        lastName
        email
        username
        title
        isIT
        isTeacher
      }
    }
  }
`

export const SCHOOL_CHECK_ONBOARDING_QUERY = gql`
  query ShowOnboarding($data: SchoolAdminOnboardingCheckRequest!) {
    schoolAdmin {
      checkOnboarding(data: $data) {
        shouldShowOnboarding
      }
    }
  }
`

export const GET_SCHOOL_ADMINS_COUNT_QUERY = gql`
  query getSchoolAdminsCount($data: CountAdminsRequest) {
    schoolAdmin {
      count(data: $data) {
        count
        activeCount
      }
    }
  }
`
